import { render, staticRenderFns } from "./UpdateProfile.vue?vue&type=template&id=725b066f&scoped=true"
import script from "./UpdateProfile.vue?vue&type=script&lang=js"
export * from "./UpdateProfile.vue?vue&type=script&lang=js"
import style0 from "./UpdateProfile.vue?vue&type=style&index=0&id=725b066f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725b066f",
  null
  
)

export default component.exports